import _ from 'lodash';
import { roleEnum } from '../enums/index';
import { sortNumberArray } from '../lib/utils';

export const getSchedule = (timetable) => {
  const schedule = {};
  if (timetable) {
    Object.keys(timetable).forEach((day) => {
      let resultArray = [];
      if (timetable[day].length > 0) {
        const timeArray = timetable[day];
        const minTime = _.minBy(timeArray, 'interval');
        const maxTime = _.maxBy(timeArray, 'interval');

        const startTimes = _.times(minTime.interval, _.constant(undefined));
        const endTimes = _.times(48 - maxTime.interval - 1, _.constant(undefined));
        resultArray = [...startTimes, ...timeArray, ...endTimes];
        // Если в расписании есть пробелы, то их строим немного по-другому
        if (maxTime.interval - minTime.interval > timeArray.length) {
          const timeWithSpaces = [];
          let index = 0;
          let timeIndex = 0;
          while (minTime.interval + index <= maxTime.interval) {
            const time = timeArray[timeIndex];
            let timeData;
            if (time && time.interval === minTime.interval + index) {
              timeData = time;
              timeIndex += 1;
            }
            index += 1;
            timeWithSpaces.push(timeData);
          }
          resultArray = [...startTimes, ...timeWithSpaces, ...endTimes];
        }
      }
      schedule[day] = resultArray;
    });
  }
  return schedule;
};

export function getSelectIntervals(booking, schedule) {
  const {
    choosenDay,
    startInterval,
    endInterval,
    chosenPart,
  } = booking;
  const times = schedule[choosenDay];
  const beforeIntervals = new Set();
  const afterIntervals = new Set();
  const startIntervalData = times.find(time =>
    time && time.interval === startInterval &&
    time.values.some(value => value.part === chosenPart));
  const startIndex = times.indexOf(startIntervalData);
  let index = startIndex;
  // Добавляем доступные интервалы для выбора "С"
  while (times[index] && times[index].values.some(item =>
    item.part === chosenPart && !item.booking && !item.blocking)) {
    beforeIntervals.add(times[index].interval);
    index -= 1;
  }
  index = startIndex;
  while (times[index] &&
    times[index].interval < endInterval &&
    times[index].values.some(item =>
      item.part === chosenPart && !item.bookings.length && !item.blocking)) {
    beforeIntervals.add(times[index].interval);
    index += 1;
  }

  // Добавляем доступные интервалы для выбора "Дo"
  const endIndex = startIndex + 1;
  index = endIndex;
  while (times[index] &&
    times[index].values.some(item =>
      item.part === chosenPart && !item.bookings.length && !item.blocking)) {
    afterIntervals.add(times[index].interval);
    index += 1;
  }
  index = endIndex;

  const afterIntervalsArray = Array.from(afterIntervals);
  const maxValue = Math.max(...afterIntervalsArray);

  return {
    // Добавляем +1, т.к. это интервал конца бронирования
    afterIntervals: [
      ...afterIntervalsArray,
      // Может быть такой случай, что значений "До" нет и max даст -Infinity
      isFinite(maxValue) ? // eslint-disable-line no-restricted-globals
        maxValue + 1 : startInterval + 1,
    ].sort(sortNumberArray),
    beforeIntervals: Array.from(beforeIntervals).sort(sortNumberArray),
  };
}

export function getPrice(booking, schedule) {
  const {
    choosenDay,
    startInterval,
    endInterval,
  } = booking;

  const times = schedule[choosenDay];

  return times.filter(time => time && time.interval >= startInterval && time.interval < endInterval)
    .reduce((sum, current) => sum + (current.price || 0), 0);
}

export function getTipData(intervalData) {
  let color = 'grey';
  let hint = 'Вне рабочего графика';
  const isBooked = intervalData && intervalData.bookings && intervalData.bookings.length;
  const isPaid = isBooked && intervalData.bookings.some(booking => booking.state === 'Paid');
  const isAdmin = isBooked &&
    intervalData.bookings.some(booking => booking.role === roleEnum.admin);
  if (isBooked) {
    if (isPaid) {
      color = 'red';
      hint = 'Оплачено';
    } else {
      color = 'yellow';
      hint = 'Забронировано (не оплачено)';
    }
    if (isAdmin) {
      color = 'darkgrey';
      hint = 'Забронировано администратором';
    }
  } else {
    color = 'green';
    hint = 'Доступно';
  }
  return { color, hint, isBooked };
}

export function formatPeriodItem(interval) {
  return `${interval % 2 === 1 ? (interval / 2) - 0.5 : interval / 2}:${interval % 2 === 1 ? '30' : '00'}`;
}

function formatClockMinutes(totalMinutes) {
  const mins = ((Number(totalMinutes) % (24 * 60)) + (24 * 60)) % (24 * 60);
  const hours = Math.floor(mins / 60);
  const minutes = mins % 60;
  return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
}

/** Подпись 30-мин слота: start — начало строки, end — exclusive конец. */
export function intervalSlotTimeRange(interval) {
  const startMin = Number(interval) * 30;
  const start = formatClockMinutes(startMin);
  const end = formatClockMinutes(startMin + 30);
  return {
    start,
    end,
    text: `${start}–${end}`,
    title: `${start} – ${end}`,
  };
}
